import { useContext, useEffect } from 'react';
import FinanceContext from '~/context/home/FinanceContext';
import { fetchCreditStatus } from '~/services/home';
import generateErrorLogger from '~/utilities/errorHandlers';

export default function useGetCreditStatus(shouldGetCreditStatus: boolean) {
  const {
    financeInfo: { setData, setError, setLoading }
  } = useContext(FinanceContext);

  useEffect(() => {
    setLoading();
    if (!shouldGetCreditStatus) return setData({});

    fetchCreditStatus()
      .then(({ data }) => {
        setData(data);
      })
      .catch(
        generateErrorLogger('Get finance info', {}, { callback: setError })
      );
  }, [setData, setError, setLoading, shouldGetCreditStatus]);
}
